import { create } from "zustand";
import { getTodaysAttendence, getUpcomingLeaves, getDashboardStats, getDailyTrackerCounts } from "@/services/HrService/DashboardService";

// Helper function to safely extract error message from various error formats
const getErrorMessage = (error) => {
  if (!error) return 'An unexpected error occurred';
  if (typeof error === 'string') return error;
  if (error.message && typeof error.message === 'string') return error.message;
  if (typeof error === 'object') {
    // Try common error object patterns
    if (error.error?.message) return error.error.message;
    if (error.msg) return error.msg;
    // Last resort: stringify but make it readable
    try {
      return JSON.stringify(error);
    } catch {
      return 'An unexpected error occurred';
    }
  }
  return 'An unexpected error occurred';
};

const useHRStore = create((set, get) => ({
  todayAttendance: null,
  upcomingLeaves: null,
  dashboardStats: null,
  trackerCounts: null,
  loading: false,
  error: null,
  fetchTodayAttendance: async () => {
    try {
      set({ loading: true });
      const response = await getTodaysAttendence();
      console.log("Attendance API Response:", response);

      if (response.success) {
        set({ todayAttendance: response.data, loading: false });
      } else {
        set({ error: getErrorMessage(response.error), loading: false });
      }
    } catch (error) {
      console.error("Fetch Attendance Error:", error);
      set({ error: getErrorMessage(error), loading: false });
      throw error;
    }
  },

  fetchUpcomingLeaves: async () => {
    try {
      set({ loading: true });
      const response = await getUpcomingLeaves();
      console.log("Upcoming Leaves API Response:", response);

      if (response.success) {
        set({ upcomingLeaves: response.data, loading: false });
      } else {
        set({ error: getErrorMessage(response.error) || 'Failed to fetch upcoming leaves', loading: false });
      }
    } catch (error) {
      console.error("Fetch Upcoming Leaves Error:", error);
      set({ error: getErrorMessage(error), loading: false });
      throw error;
    }
  },

  fetchDashboardStats: async () => {
    try {
      set({ loading: true });
      const response = await getDashboardStats();
      console.log("Dashboard Stats API Response:", response);

      if (response.success) {
        set({ dashboardStats: response.data, loading: false });
      } else {
        set({ error: getErrorMessage(response.error) || 'Failed to fetch dashboard stats', loading: false });
      }
    } catch (error) {
      console.error("Fetch Dashboard Stats Error:", error);
      set({ error: getErrorMessage(error), loading: false });
      throw error;
    }
  },

  fetchTrackerCounts: async () => {
    try {
      set({ loading: true });
      const response = await getDailyTrackerCounts();
      console.log("Tracker Counts API Response:", response);

      if (response.success) {
        set({ trackerCounts: response.data, loading: false });
      } else {
        set({ error: getErrorMessage(response.error) || 'Failed to fetch tracker counts', loading: false });
      }
    } catch (error) {
      console.error("Fetch Tracker Counts Error:", error);
      set({ error: getErrorMessage(error), loading: false });
      throw error;
    }
  },

  resetErrors: () => set({ error: null }),
}));

export default useHRStore;